import { AdjustDivisionRotationsRequest, Rotation, DivisionsProfileRotationRM } from '@herbjoy/apex-api-models';
import { IHttpService, IPromise } from 'angular';
import moment from 'moment';

export interface DivisionProfileRotationQuery {
    /**
     * If given, filter based on one or more provided division profiles.
     */
    divisionProfileID: number | number[];
}

export function sortRotationDesc(a: Rotation, b: Rotation) {
    if (moment(a.StartDate).isAfter(b.StartDate)) {
        return -1;
    } else if (moment(a.StartDate).isBefore(b.StartDate)) {
        return 1;
    }
    if (moment(a.EndDate).isAfter(b.EndDate)) {
        return -1;
    } else if (moment(a.EndDate).isBefore(b.EndDate)) {
        return 1;
    }
}

function mapRotationToDateString(rotation: Rotation) {
    return {
        StartDate: moment(rotation.StartDate).format("YYYY-MM-DD"),
        EndDate: moment(rotation.EndDate).format("YYYY-MM-DD")
    }
}

export class RotationsService {
    constructor(private $http: IHttpService, private apexApiUrl: string) {
        'ngInject'
    }

    retrieveDivisionRotations(query: DivisionProfileRotationQuery) {
        return this.$http<DivisionsProfileRotationRM[]>({
            method: "GET",
            url: `${this.apexApiUrl}division-profiles/rotations`,
            headers: { Accept: "application/json" },
            params: query
        }).then(function (response) {
            return response.data;
        });
    }

    adjustDivisionRotations(divisionProfileID: number, adjustments: AdjustDivisionRotationsRequest): IPromise<void> {
        const request = {
            DivisionProfileID: divisionProfileID,
            // Map dates to a simple date component to avoid sending timezone info.
            AdjustedRotations: adjustments.AdjustedRotations.map(function (adjustment) {
                return {
                    CurrentRotation: mapRotationToDateString(adjustment.CurrentRotation),
                    NewRotation: mapRotationToDateString(adjustment.NewRotation)
                }
            }),
            NewRotations: adjustments.NewRotations.map(mapRotationToDateString),
            DeletedRotations: adjustments.DeletedRotations.map(mapRotationToDateString),
            RetainedTimeEntries: adjustments.RetainedTimeEntries,
            IgnoreLockedPayrolls: adjustments.IgnoreLockedPayrolls
        };

        return this.$http<void>({
            method: "PATCH",
            url: `${this.apexApiUrl}division-profiles/${divisionProfileID}/rotations`,
            data: request,
            headers: { Accept: "application/json", "Content-Type": "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }
}
